'use client';
import Link from 'next/link';
import { ArrowLeft, Mail, Phone, MapPin } from 'lucide-react';

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-3">Contact Us</h1>
        <p className="text-slate-500 text-sm mb-10">We are here to help. Reach out to us through any of the channels below.</p>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 mb-10">
          <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-blue-50 flex items-center justify-center flex-shrink-0">
              <Mail size={18} className="text-[#1a56ff]" />
            </div>
            <div>
              <div className="text-sm font-semibold text-[#0f172a] mb-1">Email Support</div>
              <a href="mailto:support@dropservice.in" className="text-sm text-[#1a56ff] hover:underline">support@dropservice.in</a>
              <div className="text-xs text-slate-400 mt-1">Response within 24 hours</div>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center flex-shrink-0">
              <Phone size={18} className="text-emerald-600" />
            </div>
            <div>
              <div className="text-sm font-semibold text-[#0f172a] mb-1">WhatsApp Support</div>
              <div className="text-sm text-slate-500">Available on dashboard</div>
              <div className="text-xs text-slate-400 mt-1">Mon–Sat, 10am–7pm IST</div>
            </div>
          </div>
          <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm flex items-start gap-4">
            <div className="w-10 h-10 rounded-xl bg-purple-50 flex items-center justify-center flex-shrink-0">
              <MapPin size={18} className="text-purple-600" />
            </div>
            <div>
              <div className="text-sm font-semibold text-[#0f172a] mb-1">Registered Office</div>
              <div className="text-sm text-slate-500">Kanglei Sannathong Pvt. Limited</div>
              <div className="text-xs text-slate-400 mt-1">India</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
